<main class="agents-list-page">
  <app-ui-page-header
    title="Agentes"
    subtitle="Agentes criados, status operacional e acesso rápido à configuração."
    [count]="agents().length"
    density="compact"
    [divider]="false"
  >
    <div actions class="flex flex-wrap gap-2">
      <button appButton variant="primary" type="button" (click)="startNewAgent()">
        <ng-icon name="heroPlus" size="16" aria-hidden="true" />
        Novo agente
      </button>
      <button appButton variant="secondary" type="button" (click)="refresh()" [disabled]="loading()">
        <ng-icon name="heroArrowPath" size="16" aria-hidden="true" />
        Atualizar
      </button>
    </div>
  </app-ui-page-header>

  <section appUiFilterBar aria-label="Filtros de agentes">
    <label appUiFilterSearch>
      <span class="sr-only">Buscar agentes</span>
      <ng-icon
        name="heroMagnifyingGlass"
        size="16"
        aria-hidden="true"
        class="pointer-events-none absolute left-3 top-1/2 z-[1] -translate-y-1/2 text-muted"
      />
      <input
        appInput
        leadingIcon
        type="search"
        aria-label="Buscar agentes"
        placeholder="Buscar por nome, descrição ou objetivo"
        [value]="search()"
        (input)="setSearchFromEvent($event)"
      />
    </label>

    <div appUiFilterField>
      <span appUiFilterLabel>Status</span>
      <button
        appSelect
        type="button"
        aria-label="Filtrar por status"
        [ngpSelectValue]="statusFilter()"
        (ngpSelectValueChange)="setStatusFilter($event)"
      >
        <span>{{ selectedStatusLabel() }}</span>
        <div *ngpSelectPortal appSelectDropdown>
          @for (option of statusFilterOptions; track option.value) {
            <div appSelectOption [ngpSelectOptionValue]="option.value">{{ option.label }}</div>
          }
        </div>
      </button>
    </div>

    <div appUiFilterField>
      <span appUiFilterLabel>Objetivo</span>
      <button
        appSelect
        type="button"
        aria-label="Filtrar por objetivo"
        [ngpSelectValue]="objectiveFilter()"
        (ngpSelectValueChange)="setObjectiveFilter($event)"
      >
        <span>{{ selectedObjectiveLabel() }}</span>
        <div *ngpSelectPortal appSelectDropdown>
          @for (option of objectiveFilterOptions(); track option.value) {
            <div appSelectOption [ngpSelectOptionValue]="option.value">{{ option.label }}</div>
          }
        </div>
      </button>
    </div>

    @if (hasActiveFilters()) {
      <div appUiFilterActions>
        <button appButton variant="ghost" type="button" (click)="clearFilters()">Limpar</button>
      </div>
    }
  </section>

  <section class="list-content" aria-label="Lista de agentes">
    @if (loading() && agents().length === 0) {
      <app-ui-resource-grid minColumnWidth="20rem" [loading]="true" aria-hidden="true">
        @for (item of [1, 2, 3, 4, 5, 6]; track item) {
          <app-ui-resource-card-skeleton layout="mediaText" minHeight="14rem" />
        }
      </app-ui-resource-grid>
    } @else if (visibleAgents().length === 0) {
      <app-ui-empty-state
        icon="heroCpuChip"
        title="Nenhum agente encontrado"
        description="Ajuste os filtros ou crie um novo agente para começar."
      >
        @if (hasActiveFilters()) {
          <button actions appButton variant="secondary" type="button" (click)="clearFilters()">Limpar filtros</button>
        } @else {
          <button actions appButton variant="primary" type="button" (click)="startNewAgent()">
            <ng-icon name="heroPlus" size="16" aria-hidden="true" />
            Novo agente
          </button>
        }
      </app-ui-empty-state>
    } @else {
      <app-ui-resource-grid minColumnWidth="20rem" role="list">
        @for (agent of visibleAgents(); track agent.id) {
          <app-ui-resource-card minHeight="14rem" role="listitem" [ariaLabel]="'Agente ' + agent.name">
            <div appUiResourceCardHeader>
              <span class="objective-icon" aria-hidden="true">
                <ng-icon [name]="agentObjectiveIcon(agent)" size="19" />
              </span>
              <span appBadge [tone]="statusTone(agent.status)" size="xs">{{ statusLabel(agent.status) }}</span>
            </div>

            <div appUiResourceCardBody>
              <h2 appUiResourceCardTitle>{{ agent.name }}</h2>
              <p appUiResourceCardDescription>{{ agentDescription(agent) }}</p>
              <p appUiResourceCardMeta>{{ agentObjectiveLabel(agent) }}</p>
            </div>

            <div appUiResourceCardFooter [separated]="true">
              <span appBadge tone="neutral" size="xs">{{ currentVersionLabel(agent) }}</span>
              <div class="agent-card__actions">
                <button appButton variant="ghost" size="sm" type="button" (click)="viewAgent(agent)">
                  Visualizar
                </button>
                <button
                  appButton
                  variant="ghost"
                  size="sm"
                  class="card-menu-trigger"
                  type="button"
                  [ngpMenuTrigger]="agentActionsMenu"
                  ngpMenuTriggerPlacement="bottom-end"
                  [attr.aria-label]="'Ações de ' + agent.name"
                >
                  <ng-icon name="heroEllipsisVertical" size="17" aria-hidden="true" />
                </button>
              </div>

              <ng-template #agentActionsMenu>
                <div appMenuPanel>
                  <button appMenuItem type="button" (click)="viewAgent(agent)">
                    <span>Visualizar</span>
                    <ng-icon name="heroEye" size="15" aria-hidden="true" />
                  </button>
                  <button appMenuItem type="button" (click)="editAgent(agent)">
                    <span>Editar</span>
                    <ng-icon name="heroPencilSquare" size="15" aria-hidden="true" />
                  </button>
                  <div appMenuSeparator></div>
                  <button
                    appMenuItem
                    tone="danger"
                    type="button"
                    [ngpMenuItemDisabled]="isArchivingAgent(agent.id)"
                    (click)="archiveAgent(agent)"
                  >
                    <span>Excluir</span>
                    <ng-icon name="heroTrash" size="15" aria-hidden="true" />
                  </button>
                </div>
              </ng-template>
            </div>
          </app-ui-resource-card>
        }
      </app-ui-resource-grid>
    }
  </section>
</main>
